import { page } from '@hbf/analytics';
import { setRemarketingTag } from './setRemarketingTag';

/**
 *
 * @param {Object} payload
 * @param {string} payload.category
 * @param {string} payload.name
 * @param {object} payload.traits
 * @param {*} payload.remarketingTag
 * @param {boolean} payload.hideIntercom
 * @returns {import('ha/myredux/types').Thunk}
 */
export const onPageMount =
  ({ category, name, traits, remarketingTag, hideIntercom }) =>
  (dispatch, _, { analytics }) => {
    return analytics.onUserIdentified(mixpanel => {
      // https://mixpanel.com/blog/2015/01/06/community-tip-tracking-first-time-users
      // Register a qsuper-property to track "First time" users.
      // It will be stored in cookies, and it doesn't require any HTTP requests to MixPanel.
      // All next events of the user will include this super-property.

      page(category, name, traits, {
        integrations: { Intercom: { hideDefaultLauncher: hideIntercom } },
      });

      if (mixpanel) {
        mixpanel.register({ 'First Time': 'FALSE' });
      }

      if (remarketingTag) {
        setRemarketingTag(remarketingTag);
      }
    });
  };
